import React from 'react';
import LocationTemplate from './LocationTemplate';

const WalstonburgPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Walstonburg"
      stateName="North Carolina"
      countyName="Greene"
      zipCodes={["27888"]}
      latitude={35.5957}
      longitude={-77.6992}
      population={219}
      historicalFact="Incorporated in 1877, named after the Walston family who were early settlers."
      nearbyTowns={[
        "Snow Hill, NC",
        "Stantonsburg, NC",
        "Hookerton, NC",
        "Farmville, NC",
        "Wilson, NC",
        "Black Creek, NC",
        "Elm City, NC",
        "Fountain, NC"
      ]}
    />
  );
};

export default WalstonburgPage;